/**
 * API 클라이언트 설정 — v2-only.
 *
 * The app targets the v2 BE exclusively (`getNewApiBaseUrl`). The legacy
 * `getApiBaseUrl`/`getAuthEndpoint` helpers (VITE_API_BASE_URL / VITE_PROXY_TARGET)
 * were removed in the v2-only migration — nothing calls `/api2 /api3` anymore.
 */

/**
 * New admin REST API (/api-v2/admin, /api-v2/advertiser, /api-v2/influencer) base URL.
 *
 * The `/api-v2/` prefix namespace serves two purposes:
 *  1. Distinguishes the new v2 backend from legacy `/api`, `/api2`, `/api3`.
 *  2. Avoids collision with SPA page routes that share the same leading segment
 *     (e.g. `/influencer/:userId` is a page route, `/api-v2/influencer/*` is
 *     the BE API). Without the prefix, CloudFront path-based behaviors would
 *     intercept page-refresh/direct-navigation requests for those SPA routes
 *     and forward them to Heroku instead of S3.
 *
 * - Deployed (staging): `VITE_NEW_API_BASE_URL=https://api-staging.ggcontent.com`
 *   → FE calls `https://api-staging.ggcontent.com/admin/*` directly (no CloudFront routing).
 * - Deployed (production): `VITE_NEW_API_BASE_URL=https://api.ggcontent.com`
 *   → FE calls `https://api.ggcontent.com/admin/*` directly (no CloudFront routing).
 * - Local dev: Vite proxy rewrites `/api-v2/admin/*` → `/admin/*` before
 *   forwarding to the new BE host (VITE_NEW_API_BASE_URL not set → falls back to '/api-v2').
 * - Direct host override (`VITE_NEW_API_BASE_URL`): the full URL is used as-is
 *   (no `/api-v2` prefix injected) so the BE is called at its native paths.
 */
export const getNewApiBaseUrl = (): string => {
  const base = import.meta.env.VITE_NEW_API_BASE_URL;
  if (base) {
    return base.replace(/\/$/, '');
  }
  return '/api-v2'; // relative path with /api-v2 prefix — same-origin routing via CloudFront or Vite proxy
};
